import { makeStyles } from "tss-react/mui";

interface IParams {
    isMobileOrTablet: boolean;
    isMobile: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, { isMobileOrTablet, isMobile }) => ({
    container: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        maxWidth: 1280,
        margin: "0 auto",
        borderRadius: isMobileOrTablet ? 0 : theme.shape.borderRadius,
        backgroundColor: theme.palette.background.main,
        "& > div": {
            paddingBottom: isMobile ? 0 : undefined,
        },
    },
}));
